import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/cookie-policy" element={<Legal kind="cookie" />} />
        <Route path="/termini" element={<Legal kind="terms" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
